import { InsightCatalogue } from '../InsightCatalogue';
import {
  AggregateOnlyInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface UsersAvailableHoursPayload
  extends AggregateOnlyInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS;
    id: string;
    attributes: {
      aggregate: {
        total_available_hours: InsightMetric;
      };
    };
  };
}

export const parseUsersAvailableHoursPayload = (
  payload: BaseInsightPayload
): UsersAvailableHoursPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS,
    data.attributes,
    false,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    aggregate: {
      total_available_hours: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_USERS_AVAILABLE_HOURS,
      id: data.id,
      attributes: {
        aggregate: {
          total_available_hours:
            typedAttributes.aggregate.total_available_hours,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
